const theme = window.getComputedStyle(document.body);

const themeColors = {
  grayPrimary: theme.getPropertyValue('--theme-color-gray-darker'),
  graySecondary: theme.getPropertyValue('--theme-color-gray-dark'),
  grayTertiary: theme.getPropertyValue('--theme-color-gray'),
  grayLight: theme.getPropertyValue('--theme-color-gray-light'),

  primary: theme.getPropertyValue('--theme-color-primary'),
  primaryLight: theme.getPropertyValue('--theme-color-primary-light'),
  primaryLightHover: theme.getPropertyValue('--theme-color-primary-light-hover'),
  primaryDark: theme.getPropertyValue('--theme-color-primary-dark'),

  secondary: theme.getPropertyValue('--theme-color-gray-dark'),
  tertiary: theme.getPropertyValue('--theme-color-secondary'),
  danger: theme.getPropertyValue('--theme-color-danger'),
  white: theme.getPropertyValue('--theme-color-white'),

  socialTwitter: theme.getPropertyValue('--theme-color-social-twitter'),
  socialFacebook: theme.getPropertyValue('--theme-color-social-facebook'),
  socialGoogle: theme.getPropertyValue('--theme-color-social-google'),
  socialNextdoor: theme.getPropertyValue('--theme-color-social-nextdoor'),
};

//eslint-disable-next-line import/prefer-default-export
export const lsColors = {
  'current-color': 'currentColor',
  'gray-primary': themeColors.grayPrimary || '#4a4a4a',
  'gray-secondary': themeColors.graySecondary || '#9b9b9b',
  'gray-tertiary': themeColors.graySecondary || '#adadad',
  primary: themeColors.primary || '#0ab463',
  'primary-light': themeColors.primaryLight || '#d8f3e6',
  'primary-dark': themeColors.primaryDark || '#1b8b53',
  secondary: themeColors.secondary || '#9b9b9b',
  tertiary: themeColors.tertiary || '#ff9900',
  danger: themeColors.danger || '#de4343',
  info: '#a84194',
  white: themeColors.white || '#fff',
  transparent: 'transparent',
  // special one-off colors
  'special-primary-hover': '#8cd9b3',
  'special-navbar-overlay': themeColors.grayTertiary || '#d8d8d8',
  'special-recommended-services': themeColors.primaryLightHover || '#bfe9d5',
  'special-recommended-services-background': themeColors.grayLight || '#e2e4e3',

  // social colors
  'social-twitter': themeColors.socialTwitter || '#1da1f2',
  'social-facebook': themeColors.socialFacebook || '#3b5998',
  'social-google': themeColors.socialGoogle || '#4885ed',
  'social-nextdoor': themeColors.socialNextdoor || '#1d9659',
};
